require('./bootstrap');
window.$ = window.jQuery = require('jquery');
require('fancybox');
require('babel-polyfill');

import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VeeValidate, { Validator } from 'vee-validate'
import sl from 'vee-validate/dist/locale/sl'
import route from './route'

window.route = route;
window.Vue = Vue;


Vue.use(VueCookies)	

// matomo tag manager analitics script
const analitycsConsented = VueCookies.get("analytics-consent") == null ? false : (VueCookies.get("analytics-consent") == "true" ? true : false);
if (analitycsConsented) {
    // create script element and set attributes
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute("type", "text/javascript");
    scriptElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_7lHgEpZP.js");
    document.head.prepend(scriptElement);

    // create noscript element and set attributes
    const noScriptElement = document.createElement("noscript");
    const iframeElement = document.createElement("iframe");
    iframeElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_7lHgEpZP.js");
    iframeElement.setAttribute("height", "0");
    iframeElement.setAttribute("width", "0");
    iframeElement.setAttribute("style", "display:none;visibility:hidden");
    noScriptElement.appendChild(iframeElement);
    document.body.prepend(noScriptElement);
}



Vue.use(VeeValidate, {
  events: 'change'
});
Validator.localize('sl', sl);
Vue.use(VeeValidate)

Vue.component('home-slideshow', require('./components/HomeSlideshow.vue'));
Vue.component('accordion', require('./components/Accordion.vue'));
Vue.component('cookie-consent', require('./components/CookieConsent.vue'));
Vue.component('cookie-consent-details', require('./components/CookieConsentDetails.vue'));
Vue.component('collection', require('./components/Collection.vue'));
Vue.component('collection-advanced', require('./components/CollectionAdvanced.vue'));
Vue.component('collection-mauthor', require('./components/CollectionMauthor.vue'));
Vue.component('collection-maximal', require('./components/CollectionMaximal.vue'));
Vue.component('collection-multi', require('./components/CollectionMulti.vue'));
Vue.component('collection-slo', require('./components/CollectionSlo.vue'));
Vue.component('collection-rendered', require('./components/CollectionRendered.vue'));
Vue.component('spinner', require('./components/Spinner.vue'));
Vue.component('activation-code', require('./components/ActivationCode.vue'));
Vue.component('popup-stack', require('./components/PopupStack.vue'));
Vue.component('dropdown', require('./components/Dropdown.vue'));
Vue.component('additional-content', require('./components/AdditionalContent.vue'));
Vue.component('news', require('./components/News.vue'));
Vue.component('news-single', require('./components/NewsSingle.vue'));

// import popupIzzi from './components/PopupIzzi.vue'
// import popupThinkDigital from './components/PopupThinkDigital.vue';

Vue.mixin({
  methods: {
  	route: route
  }
});

const app = new Vue({
	el: '#app',
  data: {
    userStatus: null
  },
  mounted() {
    axios.get(window.route('status')).then((response) => {
      this.userStatus = response.data.status;
      const popupConsented = this.$cookies.get("site-popup-consent") == null ? false : (this.$cookies.get("site-popup-consent") == "true" ? true : false);
      if (popupConsented) {
        // this.$root.$emit('add-popup', popupIzzi);
        // if (this.userStatus == 'teacher') {
        //   this.$root.$emit('add-popup', popupThinkDigital);
        // }
      }
    }, (reason) => {
      console.error(reason);
    });
  },
    methods: {
      showConsent() {
          this.$root.$emit('show-consent');
      }
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js